/*=========================================================================================
  File Name: modulePurchaseGetters.js
  Description: Purchase Module Getters
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {};
